import { createTrainings, updateTrainings } from 'api/training';
import { debounceRegional } from 'utils/debounces';

import type { FormType } from '..';

export const trainingForm: FormType = {
  createFn: createTrainings,
  updateFn: updateTrainings,
  cancelText: 'Cancelar',
  submitText: 'Salvar Treinamento',
  disableText: 'Desativar Treinamento',
  enableText: 'Reativar Treinamento',
  successText: 'Treinamento salvo com sucesso!',
  fields: [
    [
      {
        name: 'name',
        type: 'text',
        required: true,
        props: {
          placeholder: 'Treinamento 1',
          label: 'Nome',
        },
      },
    ],
    [
      {
        name: 'regional',
        type: 'select',
        required: false,
        props: {
          placeholder: 'Buscar',
          label: 'Regional',
          loadOptions: debounceRegional,
        },
      },
    ],
    [
      {
        name: 'description',
        type: 'textarea',
        required: true,
        props: {
          placeholder: 'Descrição detalhada do treinamento',
          label: 'Descrição',
        },
      },
    ],
    [
      {
        name: 'startDate',
        type: 'date',
        required: true,
        props: {
          placeholder: '01/01/2000',
          label: 'Data de Início',
        },
      },
      {
        name: 'dueDate',
        type: 'date',
        required: true,
        props: {
          placeholder: '01/01/2000',
          label: 'Data da Conclusão',
        },
      },
    ],
    [],
    [
      {
        name: 'contents',
        type: 'array',
        isMultiple: true,
        required: true,
        fields: [
          {
            name: 'label',
            type: 'text',
            required: true,
            props: {
              placeholder: 'Ex: Video 1',
              label: 'Label',
            },
          },
          {
            name: 'url',
            type: 'text',
            required: true,
            props: {
              placeholder: 'https://link.com',
              label: 'Link',
            },
          },
        ],
      },
    ],
  ],
};
